export class AccountSelectorInfo {
    accountType: string;
    title: string;
    accountLabelCode: string;
    glAccountNumber: string;
    offsetGLAccountNumber: string;
    disableSubCategory: boolean;
    subCategoryCode: string;
}
